import React from 'react';
import tw from 'twin.macro';
import styled from 'styled-components';

const SkeletonContainer = tw.div`w-full sm:w-1/2 md:w-1/3 lg:w-1/4 sm:pr-10 md:pr-6 lg:pr-12`;

const SkeletonCard = styled.div`
	${tw`bg-gray-200 rounded-b block max-w-xs mx-auto sm:max-w-none sm:mx-0 overflow-hidden`}
	min-width: 284px;
	min-height: 400px;
	animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;

	@keyframes pulse {
		0%,
		100% {
			opacity: 1;
		}
		50% {
			opacity: 0.5;
		}
	}
`;

const ImageSkeleton = tw.div`h-56 xl:h-64 bg-gray-300 rounded-t`;

const TextSkeleton = tw.div`p-4`;

const TitleSkeleton = styled.div`
	${tw`h-6 bg-gray-300 rounded w-3/4 mb-3`}
`;

const PriceSkeleton = styled.div`
	${tw`h-5 bg-gray-300 rounded w-1/2`}
`;

const CardSkeleton = () => {
	return (
		<SkeletonContainer>
			<SkeletonCard>
				<ImageSkeleton />
				<TextSkeleton>
					<TitleSkeleton />
					<PriceSkeleton />
				</TextSkeleton>
			</SkeletonCard>
		</SkeletonContainer>
	);
};

export default CardSkeleton;
